import { createIcon } from '../createIcon';
import { ReactComponent as IconQuestionCircle } from '../svg/question-circle.svg';

export default createIcon(IconQuestionCircle);
